import { FunctionComponent, useContext } from 'react'
import { Chip, Stack, Typography } from '@mui/material'
import { CalendarToday } from '@mui/icons-material'
import moment from 'moment'
import { IReportAction } from '../../../../../shared/services/report-action/report-action.model'
import { IUserDetails } from '../../../../../shared/services/user-details/user-details.model'
import { UserDetailsContext } from '../../../../../context/user-details/user-details'
import { AssignActionOwner } from './assign-action-owner'

export const EmissionsActionCardHeading: FunctionComponent<{
  reportAction: IReportAction,
  completed?: boolean,
  status?: 'outstanding' | 'completed' | 'upcoming',
  getGroup?: () => void,
  users: IUserDetails[],
  viewActions?: 'actions' | 'input',
}> = ({
  reportAction,
  completed,
  status,
  getGroup,
  users,
  viewActions,
}) => {

    const userDetailsContext = useContext(UserDetailsContext)
    const userDetails = userDetailsContext.userDetails

    return (
      <>
        <Stack display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' sx={{ pb: 0.5, mr: !reportAction.dataDetected ? 10 : 0 }}>
          <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary' }}>
            {reportAction.title}
          </Typography>
          {status === 'outstanding' && reportAction.dataDetected &&
            <Chip label='Data Detected' color='primary' />
          }
        </Stack>
        <Typography variant='body2' sx={{ color: 'text.secondary', pb: 2 }}>
          {reportAction.actionBillingPeriod === 'monthly' && reportAction.actionCode === 'vehicle' && reportAction.vehicle && `Add the ${reportAction.actionPeriod} emission data for your ${reportAction.category?.friendlyName?.toLowerCase() ?? 'vehicle'} for ${reportAction.vehicle.subsidiary?.name ?? 'this subsidiary'}`}
          {reportAction.actionBillingPeriod === 'annually' && reportAction.actionCode === 'vehicle' && reportAction.vehicle && `Add the ${moment(reportAction.startDate).year() === moment(reportAction.endDate).year() ? moment(reportAction.startDate).year() : `${moment(reportAction.startDate).year()} - ${moment(reportAction.endDate).year()}`} emission data for your ${reportAction.category?.friendlyName?.toLowerCase() ?? 'vehicle'} for ${reportAction.vehicle.subsidiary?.name ?? 'this subsidiary'}`}
          {reportAction.actionBillingPeriod === 'monthly' && (reportAction.actionCode === 'location_gas' || reportAction.actionCode === 'location_aircon' || reportAction.actionCode === 'location_steam' || reportAction.actionCode === 'location_electricity' || reportAction.actionCode === 'location_water' || reportAction.actionCode === 'location_waste') && `Add the ${reportAction.actionPeriod} emission data for your ${reportAction.category?.friendlyName?.toLowerCase() ?? 'location'} for ${reportAction.location?.friendlyName ?? 'this location'}`}
          {reportAction.actionBillingPeriod === 'annually' && (reportAction.actionCode === 'location_gas' || reportAction.actionCode === 'location_aircon' || reportAction.actionCode === 'location_steam' || reportAction.actionCode === 'location_electricity' || reportAction.actionCode === 'location_water' || reportAction.actionCode === 'location_waste') && `Add the ${moment(reportAction.startDate).year() === moment(reportAction.endDate).year() ? moment(reportAction.startDate).year() : `${moment(reportAction.startDate).year()} - ${moment(reportAction.endDate).year()}`} emission data for your ${reportAction.category?.friendlyName?.toLowerCase() ?? 'location'} for ${reportAction.location?.friendlyName ?? 'this location'}`}
          {!reportAction.vehicle && reportAction.actionCode === 'utilities' && `Add the ${moment(reportAction.startDate).year() === moment(reportAction.endDate).year() ? moment(reportAction.startDate).year() : `${moment(reportAction.startDate).year()} - ${moment(reportAction.endDate).year()}`} emission data for your utilities for ${reportAction.location?.friendlyName ?? 'this location'}`}
        </Typography>
        <Stack display='flex' flexDirection='row' alignItems='center' justifyContent='space-between'>
          <Stack display='flex' flexDirection='row' alignItems='center' gap={1}>
            <CalendarToday sx={{ color: 'text.secondary' }} />
            <Typography variant='body2' sx={{ color: 'text.secondary' }}>
              {reportAction.actionBillingPeriod === 'monthly' && `${reportAction.actionPeriod} ${reportAction.actionYear}`}
              {reportAction.actionBillingPeriod === 'annually' && `Year ${moment(reportAction.startDate).year() === moment(reportAction.endDate).year() ? moment(reportAction.startDate).year() : `${moment(reportAction.startDate).year()} - ${moment(reportAction.endDate).year()}`}`}
            </Typography>
          </Stack>
          <AssignActionOwner
            reportAction={reportAction}
            users={users}
            disabled={completed || !userDetails?.roles.includes('admin') || viewActions === 'input'}
            onAssigned={getGroup}
          />
        </Stack>
      </>
    )
  }
